import styled from 'styled-components';

import { colors, cssBreakpoints, transition } from 'theme/theme';

export const MobileTableOfContentsContainer = styled.div<{ $bottom: number }>`
  z-index: 2;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
  position: fixed;
  ${(props) => `bottom: ${props.$bottom}px`};
  width: 100%;
  transition: all ${transition};
`;

export const MobileTableOfContentsHandle = styled.div`
  cursor: pointer;
  display: inline-block;
  margin-left: 50px;
  padding: 10px 24px 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  color: ${colors.mediumContentGrey};
  font-size: 14px;
  background-color: ${colors.softBlue};
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  clip-path: inset(-6px -6px 0px -6px);
`;

export const MobileTableOfContentsContent = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  background-color: white;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  font-size: 14px;
  padding-right: 16px;
`;

export const MobileTableOfContentsParentRow = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px 0;
`;

export const MobileTableOfContentsParentRowIcon = styled.div`
  width: 47px;
`;

export const MobileTableOfContentsChildren = styled.div<{ $open: boolean }>`
  max-height: 0;
  overflow: hidden;
  ${(props) => props.$open && `max-height: 100px`};
  transition: all ${transition};
`;

export const MobileTableOfContentsChildRow = styled.div`
  cursor: pointer;
  padding: 13px 0;
  margin-left: 64px;
`;
